export type ComposableCommerceEvents = {};
